import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useUserRoleContext } from 'hooks/useUserRoleContext';
import Table from './components/table';
import Breadcrumbs from 'components/breadcrumbs';
import { licenseBreadcrumbs } from './breadcrumbs';
import {
  MS_OFFICE_LICENSES,
  OFFICE_365_EDUCATION,
  OFFICE_APPLICATIONS_PACKAGE,
  WINDOWS_LICENSES,
} from './config';
import { Roles } from 'enums/userRoles';

export default function Licenses() {
  const { t } = useTranslation();
  const role = useUserRoleContext();

  return (
    <>
      <Box pb={[2, 4]}>
        <Breadcrumbs items={licenseBreadcrumbs()} />
      </Box>
      <Typography variant="h1" pb={2}>
        {t('licenses.title')}
      </Typography>
      {role === Roles.Student && <>
        <Typography variant="body1" py={2} pt={2}>
          {t('licenses.table.subtitle.msOffice')}
          {OFFICE_365_EDUCATION.map((app) => (
            <b>{` ${app}${OFFICE_365_EDUCATION.indexOf(app) === OFFICE_365_EDUCATION.length - 1 ? '.' : ','} `}</b>
          ))}
        </Typography>
        <Typography variant="body1">
          {t('licenses.student.subtitle')}
        </Typography>
        <Box py={2} pl={3}>
          {[1, 2, 3, 4, 5].map((step) =>
            <Typography variant="body1" py={1}
              dangerouslySetInnerHTML={{
                __html: `${step}. ${t(`licenses.student.step${step}`, { linkOffice: 'https://office.com', linkEduMon: 'https://edu.mon.bg' })}`
              }} />
          )}
        </Box>
        <Typography variant="body1" pt={3}>
          {t('licenses.studentMobile.subtitle')}
        </Typography>
        <Box py={2} pl={3}>
          {[1, 2].map((step) =>
            <Typography variant="body1" py={1}
              dangerouslySetInnerHTML={{
                __html: `${step}. ${t(`licenses.studentMobile.step${step}`, { linkOffice: 'https://office.com', linkEduMon: 'https://edu.mon.bg' })}`
              }} />
          )}
        </Box>
      </>
      }
      {role !== Roles.Student && <>
        <Typography variant="body1" py={2}>
          {t('licenses.table.subtitle.msOfficeDownload')}
        </Typography>
        <Table data={MS_OFFICE_LICENSES} />
        <Typography variant="body1" pt={3}>
          {t('licenses.officePackageList')}
          {OFFICE_APPLICATIONS_PACKAGE.map((app) => (
            <b>{` ${app}${OFFICE_APPLICATIONS_PACKAGE.indexOf(app) === OFFICE_APPLICATIONS_PACKAGE.length - 1 ? '.' : ','} `}</b>
          ))}
        </Typography>
        <Typography variant="body1" py={2}>
          {t('licenses.table.subtitle.windows')}
        </Typography>
        <Table data={WINDOWS_LICENSES} />
      </>}
    </>
  );
}
